import {useRef} from "react";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {AllCreditGtmEventActions, creditCalculatorAnalytics, CreditCalculatorGTMEvent} from "./credit_gtm";

export const useManageGtmEvent = (source: CreditApplicationSource) => {
    const sendEventsRef = useRef<AllCreditGtmEventActions[]>([]);

    const eventFromSource = (() => {
        switch (source) {
            case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING:
                return CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR;
            case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT:
                return CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR;
            default:
                return CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR;
        }
    })();

    const sendCreditEvent = (action: AllCreditGtmEventActions) => {
        sendEventsRef.current = [...sendEventsRef.current, action];
        creditCalculatorAnalytics.gtm.creditCalculatorEvent(eventFromSource, {
            credit_action: action
        });
    };

    return {
        eventFromSource,
        sendEvents: sendEventsRef.current,
        sendCreditEvent
    };
};
import {useRef} from "react";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {AllCreditGtmEventActions, creditCalculatorAnalytics, CreditCalculatorGTMEvent} from "./credit_gtm";

export const useManageGtmEvent = (source: CreditApplicationSource) => {
    const sendEventsRef = useRef<AllCreditGtmEventActions[]>([]);

    const eventFromSource = (() => {
        switch (source) {
            case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING:
                return CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR;
            case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT:
                return CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR;
            default:
                return CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR;
        }
    })();

    const sendCreditEvent = (action: AllCreditGtmEventActions) => {
        sendEventsRef.current = [...sendEventsRef.current, action];
        creditCalculatorAnalytics.gtm.creditCalculatorEvent(eventFromSource, {
            credit_action: action
        });
    };

    return {
        eventFromSource,
        sendEvents: sendEventsRef.current,
        sendCreditEvent
    };
};
